// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../static/fonts/Aeonik-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("images/agerasAccounting/navbar/invoicing.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("images/agerasAccounting/navbar/tooltip_arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("images/agerasAccounting/navbar/accounting_electricGreen.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("images/agerasAccounting/navbar/accounting_deepSeaGreen.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("images/agerasAccounting/navbar/ageras_gray.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: Aeonik;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.AgerasNavbar {
  height: 100%;
  background-color: #F6F9FF;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}
.AgerasNavbar__buttons {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  height: 108px;
}
.AgerasNavbar__buttons__tooltipWrapper {
  position: relative;
}
.AgerasNavbar__buttons__ZervantActive {
  background-color: #FFF;
  width: 54px;
  height: 54px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.AgerasNavbar__buttons__ZervantActive__body {
  width: 30px;
  height: 30px;
  -ms-flex-item-align: center;
      align-self: center;
  border: 3px solid #01FF94;
  border-radius: 8px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.AgerasNavbar__buttons__ZervantActive__body__icon {
  background: #01FF94 url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
  background-size: 16px;
  width: 24px;
  height: 24px;
  -ms-flex-item-align: center;
      align-self: center;
  border-radius: 3px;
}
.AgerasNavbar__buttons__ZervantActive__tooltip {
  position: absolute;
  left: 54px;
  top: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  visibility: hidden;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.AgerasNavbar__buttons__ZervantActive__tooltip__arrow {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  width: 6px;
  height: 12px;
}
.AgerasNavbar__buttons__ZervantActive__tooltip__hoverInfo {
  background: #002E33;
  margin-left: -1px;
  padding: 8px 12px;
  border-radius: 6px;
}
.AgerasNavbar__buttons__ZervantActive__tooltip__hoverInfo__text {
  font-weight: 400;
  font-size: 15px;
  font-family: "Aeonik", sans-serif;
  white-space: nowrap;
  color: #FFF;
}
.AgerasNavbar__buttons__ZervantActive:hover {
  background-color: #FFF;
}
.AgerasNavbar__buttons__ZervantActive:hover + .AgerasNavbar__buttons__ZervantActive__tooltip {
  visibility: visible;
  -webkit-transition: all 0.1s ease-out;
  transition: all 0.1s ease-out;
}
.AgerasNavbar__buttons__navToAccounting {
  background: #F6F9FF;
  width: 54px;
  height: 54px;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.AgerasNavbar__buttons__navToAccounting__icon {
  background: #002E33 url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center;
  background-size: 16px;
  width: 24px;
  height: 24px;
  -ms-flex-item-align: center;
      align-self: center;
  border-radius: 3px;
}
.AgerasNavbar__buttons__navToAccounting:hover {
  background: #FFF;
}
.AgerasNavbar__buttons__navToAccounting:hover .AgerasNavbar__buttons__navToAccounting__icon {
  background: #00E383 url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center;
}
.AgerasNavbar__buttons__navToAccounting__tooltip {
  position: absolute;
  left: 54px;
  top: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  visibility: hidden;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.AgerasNavbar__buttons__navToAccounting__tooltip__arrow {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  width: 6px;
  height: 12px;
}
.AgerasNavbar__buttons__navToAccounting__tooltip__hoverInfo {
  background: #002E33;
  margin-left: -1px;
  padding: 8px 12px;
  border-radius: 6px;
}
.AgerasNavbar__buttons__navToAccounting__tooltip__hoverInfo__text {
  font-weight: 400;
  font-size: 15px;
  font-family: "Aeonik", sans-serif;
  white-space: nowrap;
  color: #FFF;
}
.AgerasNavbar__buttons__navToAccounting:hover + .AgerasNavbar__buttons__navToAccounting__tooltip {
  visibility: visible;
  -webkit-transition: all 0.1s ease-out;
  transition: all 0.1s ease-out;
}
.AgerasNavbar__logo {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center;
  background-size: 24px;
  width: 54px;
  height: 54px;
}`, "",{"version":3,"sources":["webpack://./src/client/components/AgerasAccounting/AgerasNavbar/AgerasNavbar.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;EACA,4CAAA;AADF;AAkCA;EACE,YAAA;EACA,yBCoBO;EDnBP,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,8BAAA;AAhCF;AAkCE;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,aAAA;AAhCJ;AAkCI;EACE,kBAAA;AAhCN;AAmCI;EACE,sBChDE;EDiDF,WAAA;EACA,YAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;AAjCN;AAmCM;EACE,WAAA;EACA,YAAA;EACA,2BAAA;MAAA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;AAjCR;AAmCQ;EACE,4EAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;MAAA,kBAAA;EACA,kBAAA;AAjCV;AAqCM;EAzEJ,kBAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,kBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;AAuCF;AArCE;EACE,mDAAA;EACA,UAAA;EACA,YAAA;AAuCJ;AApCE;EACE,mBCpBW;EDqBX,iBAAA;EACA,iBAAA;EACA,kBAAA;AAsCJ;AApCI;EACE,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,mBAAA;EACA,WCxBE;AD8DR;AAeM;EACE,sBC9EA;ADiER;AAgBM;EACE,mBAAA;EACA,qCAAA;EAAA,6BAAA;AAdR;AAkBI;EACE,mBCrCG;EDsCH,WAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;AAhBN;AAkBM;EACE,4EAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;MAAA,kBAAA;EACA,kBAAA;AAhBR;AAmBM;EACE,gBCzGA;ADwFR;AAoBM;EACE,4EAAA;AAlBR;AAqBM;EAhHJ,kBAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,kBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;AA8FF;AA5FE;EACE,mDAAA;EACA,UAAA;EACA,YAAA;AA8FJ;AA3FE;EACE,mBCpBW;EDqBX,iBAAA;EACA,iBAAA;EACA,kBAAA;AA6FJ;AA3FI;EACE,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,mBAAA;EACA,WCxBE;ADqHR;AADM;EACE,mBAAA;EACA,qCAAA;EAAA,6BAAA;AAGR;AAEE;EACE,oEAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAAJ","sourcesContent":["@import '../../../Global/Colors';\n\n@font-face {\n  font-family: Aeonik;\n  src: url('../../../../static/fonts/Aeonik-Regular.woff2');\n}\n\n@mixin tooltipMixin {\n  position: absolute;\n  left: 54px;\n  top: 10px;\n  display: flex;\n  visibility: hidden;\n  align-items: center;\n\n  &__arrow {\n    background: url('~images/agerasAccounting/navbar/tooltip_arrow.svg');\n    width: 6px;\n    height: 12px;\n  }\n\n  &__hoverInfo {\n    background: $DeepSeaGreen;\n    margin-left: -1px;\n    padding: 8px 12px;\n    border-radius: 6px;\n\n    &__text {\n      font-weight: 400;\n      font-size: 15px;\n      font-family: 'Aeonik', sans-serif;\n      white-space: nowrap;\n      color: $White;\n    }\n  }\n}\n\n.AgerasNavbar {\n  height: 100%;\n  background-color: $Gray10;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n\n  &__buttons {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 108px;\n\n    &__tooltipWrapper {\n      position: relative;\n    }\n\n    &__ZervantActive {\n      background-color: $White;\n      width: 54px;\n      height: 54px;\n      display: flex;\n      justify-content: center;\n\n      &__body {\n        width: 30px;\n        height: 30px;\n        align-self: center;\n        border: 3px solid $ElectricGreen;\n        border-radius: 8px;\n        display: flex;\n        justify-content: center;\n\n        &__icon {\n          background: $ElectricGreen url('~images/agerasAccounting/navbar/invoicing.svg') no-repeat center;\n          background-size: 16px;\n          width: 24px;\n          height: 24px;\n          align-self: center;\n          border-radius: 3px;\n        }\n      }\n\n      &__tooltip {\n        @include tooltipMixin;\n      }\n\n      &:hover {\n        background-color: $White;\n      }\n\n      &:hover + &__tooltip {\n        visibility: visible;\n        transition: all 0.1s ease-out;\n      }\n    }\n\n    &__navToAccounting {\n      background: $Gray10;\n      width: 54px;\n      height: 54px;\n      cursor: pointer;\n      display: flex;\n      justify-content: center;\n\n      &__icon {\n        background: $DeepSeaGreen url('~images/agerasAccounting/navbar/accounting_electricGreen.svg') no-repeat center;\n        background-size: 16px;\n        width: 24px;\n        height: 24px;\n        align-self: center;\n        border-radius: 3px;\n      }\n\n      &:hover {\n        background: $White;\n      }\n\n      &:hover &__icon{\n        background: $Green url('~images/agerasAccounting/navbar/accounting_deepSeaGreen.svg') no-repeat center;\n      }\n\n      &__tooltip {\n        @include tooltipMixin;\n      }\n\n      &:hover + &__tooltip {\n        visibility: visible;\n        transition: all 0.1s ease-out;\n      }\n    }\n  }\n\n  &__logo {\n    background: url('~images/agerasAccounting/navbar/ageras_gray.svg') no-repeat center;\n    background-size: 24px;\n    width: 54px;\n    height: 54px;\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
